__turbopack_context__.v({
  "accent": "alarm-notification-modal-module__XKueOa__accent",
  "body": "alarm-notification-modal-module__XKueOa__body",
  "card": "alarm-notification-modal-module__XKueOa__card",
  "closeButton": "alarm-notification-modal-module__XKueOa__closeButton",
  "compactCard": "alarm-notification-modal-module__XKueOa__compactCard",
  "content": "alarm-notification-modal-module__XKueOa__content",
  "detailButton": "alarm-notification-modal-module__XKueOa__detailButton",
  "footer": "alarm-notification-modal-module__XKueOa__footer",
  "headerRow": "alarm-notification-modal-module__XKueOa__headerRow",
  "headline": "alarm-notification-modal-module__XKueOa__headline",
  "iconWrap": "alarm-notification-modal-module__XKueOa__iconWrap",
  "inlineViewport": "alarm-notification-modal-module__XKueOa__inlineViewport",
  "message": "alarm-notification-modal-module__XKueOa__message",
  "severityCaution": "alarm-notification-modal-module__XKueOa__severityCaution",
  "severityCritical": "alarm-notification-modal-module__XKueOa__severityCritical",
  "severityDefault": "alarm-notification-modal-module__XKueOa__severityDefault",
  "severityInfo": "alarm-notification-modal-module__XKueOa__severityInfo",
  "severityMeasure": "alarm-notification-modal-module__XKueOa__severityMeasure",
  "severityWarning": "alarm-notification-modal-module__XKueOa__severityWarning",
  "slideUpFadeIn": "alarm-notification-modal-module__XKueOa__slideUpFadeIn",
  "timestamp": "alarm-notification-modal-module__XKueOa__timestamp",
  "title": "alarm-notification-modal-module__XKueOa__title",
  "titleRow": "alarm-notification-modal-module__XKueOa__titleRow",
  "viewport": "alarm-notification-modal-module__XKueOa__viewport",
});
